export const PAGE_SIZE = 10;
const SPEND_COL_MIN_WIDTH = 135;

export const getColumnDefsByType = (
	dimension,
	dimensionHeaders,
	spendFormatter,
	showState,
	sortModel,
	showTotalSpend
) => {
	return [
		{
			headerName: dimension,
			field: 'name',
			colId: 'name',
			minWidth: 190,
			sortable: true,
			...(sortModel && sortModel.colId === 'name'
				? { sort: sortModel.sort }
				: {}),
		},
		{
			headerName: showState ? 'State' : 'Country',
			field: 'location',
			colId: 'location',
			minWidth: 112,
			maxWidth: 150,
			sortable: true,
			...(sortModel && sortModel.colId === 'location'
				? { sort: sortModel.sort }
				: {}),
		},
		...(showTotalSpend
			? [
					{
						headerName: 'Total spend',
						field: 'totalSpend',
						colId: 'totalSpend',
						type: 'numericColumn',
						headerClass: 'ag-numeric-header',
						cellStyle: { textAlign: 'right' },
						minWidth: SPEND_COL_MIN_WIDTH,
						sortable: true,
						...(sortModel && sortModel.colId === 'totalSpend'
							? { sort: sortModel.sort }
							: {}),
						valueFormatter: params => spendFormatter(params.value),
					},
			  ]
			: [
					{
						headerName: 'Direct spend',
						field: 'directSpend',
						colId: 'directSpend',
						type: 'numericColumn',
						headerClass: 'ag-numeric-header',
						cellStyle: { textAlign: 'right' },
						minWidth: SPEND_COL_MIN_WIDTH,
						maxWidth: 122,
						sortable: true,
						...(sortModel && sortModel.colId === 'directSpend'
							? { sort: sortModel.sort }
							: {}),
						valueFormatter: params => spendFormatter(params.value),
					},
					{
						headerName: 'Indirect spend',
						field: 'indirectSpend',
						colId: 'indirectSpend',
						type: 'numericColumn',
						headerClass: 'ag-numeric-header',
						cellStyle: { textAlign: 'right' },
						minWidth: SPEND_COL_MIN_WIDTH,
						maxWidth: 122,
						sortable: true,
						...(sortModel && sortModel.colId === 'indirectSpend'
							? { sort: sortModel.sort }
							: {}),
						valueFormatter: params => spendFormatter(params.value),
					},
			  ]),

		...(dimensionHeaders
			? dimensionHeaders.map(({ colName }, index) => ({
					headerName: colName,
					headerClass: `ag-numeric-header dimension-header color-${index + 1}`,
					colId: colName,
					type: 'numericColumn',
					cellStyle: { direction: 'rtl' },
					minWidth: SPEND_COL_MIN_WIDTH,
					sortable: colName !== 'Others',
					...(sortModel && sortModel.colId === colName
						? { sort: sortModel.sort }
						: {}),
					valueGetter: params => {
						return (
							params &&
							params.data &&
							params.data.spendSplit &&
							params.data.spendSplit[index]
						);
					},
					valueFormatter: params => spendFormatter(params.value),
			  }))
			: []),
	];
};
